'use client'

import { authFetch } from '@/lib/auth/auth-fetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'

/**
 * Converts between SPOT USDC and SPOT USDH via agent-signed IOC on @230.
 * Default: USDC → USDH. Pass `reverse: true` for USDH → USDC.
 */
export function useHyperliquidUsdcToUsdh() {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: async (input: { usdcAmount?: string; usdhAmount?: string; reverse?: boolean }) => {
			const r = await authFetch('/api/hyperliquid/usdc-to-usdh', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(input),
			})
			if (!r.ok) {
				const e = (await r.json().catch(() => ({}))) as { error?: string }
				throw new Error(e.error || `convert ${r.status}`)
			}
			return r.json()
		},
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ['hl-balance'] })
		},
	})
}
